import { render, staticRenderFns } from "./commodityShelvesModal.vue?vue&type=template&id=7e559142&scoped=true"
import script from "./commodityShelvesModal.vue?vue&type=script&lang=js"
export * from "./commodityShelvesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e559142",
  null
  
)

export default component.exports